import * as components from './components'

export default [
  {
    path: '/help/iconslist',
    component: components.ColorTheme,
    name: 'iconsList',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/help/routes.js